/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

const baseUrl = 'microapp-product-bridges';
const pathParameterPlaceholder = undefined;
function freeze(value) {
  return Object.freeze(value);
}

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * post-/microapp-product-bridges/v1/marketing-email-gpt/create-email/{portalId}/{uuid}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: internal ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:MarketingEmailGPTResource+type:symbol+createMarketingEmail&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Marketing_Email_GP_T-post-%2Fmicroapp-product-bridges%2Fv1%2Fmarketing-email-gpt%2Fcreate-email%2F%7BportalId%7D%2F%7Buuid%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/post/api.hubapi.com%2Fmicroapp-product-bridges%2Fv1%2Fmarketing-email-gpt%2Fcreate-email%2F%28%28%7BportalId%7D%29%29%2F%28%28%7Buuid%7D%29%29?showRequestDetails=true&body=&authType=internal)</span></span><span style='padding-left: 12px'></span></span>
 */
export const createMarketingEmailGptRpc = freeze({
  baseUrl,
  method: 'post',
  pathSegments: freeze(['v1/marketing-email-gpt/create-email', pathParameterPlaceholder, pathParameterPlaceholder]),
  pathParameters: freeze(['portalId', 'uuid'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/microapp-product-bridges/v1/live-chat/{stateId}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:ChatStateResource+type:symbol+getState&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Chat_State-get-%2Fmicroapp-product-bridges%2Fv1%2Flive-chat%2F%7BstateId%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fmicroapp-product-bridges%2Fv1%2Flive-chat%2F%28%28%7BstateId%7D%29%29?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getChatStateRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/live-chat', pathParameterPlaceholder]),
  pathParameters: freeze(['stateId'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/microapp-product-bridges/v1/marketing-email-gpt/preview/{uuid}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: internal ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:MarketingEmailGPTResource+type:symbol+get&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Marketing_Email_GP_T-get-%2Fmicroapp-product-bridges%2Fv1%2Fmarketing-email-gpt%2Fpreview%2F%7Buuid%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fmicroapp-product-bridges%2Fv1%2Fmarketing-email-gpt%2Fpreview%2F%28%28%7Buuid%7D%29%29?showRequestDetails=true&body=&authType=internal&headers=Accept:%20text%2Fhtml%0AContent-Type:%20application%2Fjson)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getMarketingEmailGptPreviewRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/marketing-email-gpt/preview', pathParameterPlaceholder]),
  pathParameters: freeze(['uuid'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/microapp-product-bridges/v1/meeting/{stateId}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:MeetingStateResource+type:symbol+getState&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Meeting_State-get-%2Fmicroapp-product-bridges%2Fv1%2Fmeeting%2F%7BstateId%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fmicroapp-product-bridges%2Fv1%2Fmeeting%2F%28%28%7BstateId%7D%29%29?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getMeetingStateRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/meeting', pathParameterPlaceholder]),
  pathParameters: freeze(['stateId'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * post-/microapp-product-bridges/v1/screenshot/{domain}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: internal ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:ScreenshotResource+type:symbol+screenshot&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Screenshot-post-%2Fmicroapp-product-bridges%2Fv1%2Fscreenshot%2F%7Bdomain%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/post/api.hubapi.com%2Fmicroapp-product-bridges%2Fv1%2Fscreenshot%2F%28%28%7Bdomain%7D%29%29?showRequestDetails=true&body=%7B%22imgWidth%22:0,%22imgHeight%22:0%7D&authType=internal)</span></span><span style='padding-left: 12px'></span></span>
 */
export const screenshotRpc = freeze({
  baseUrl,
  method: 'post',
  pathSegments: freeze(['v1/screenshot', pathParameterPlaceholder]),
  pathParameters: freeze(['domain'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * post-/microapp-product-bridges/v1/live-chat
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: internal ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:ChatStateResource+type:symbol+storeState&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Chat_State-post-%2Fmicroapp-product-bridges%2Fv1%2Flive-chat'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/post/api.hubapi.com%2Fmicroapp-product-bridges%2Fv1%2Flive-chat?showRequestDetails=true&body=%7B%22accentColor%22:%22string%22,%22textColor%22:%22string%22,%22firstName%22:%22string%22,%22lastName%22:%22string%22,%22companyDomain%22:%22string%22,%22companyName%22:%22string%22,%22customChatName%22:%22string%22,%22welcomeMessage%22:%22string%22,%22background%22:%22string%22%7D&authType=internal)</span></span><span style='padding-left: 12px'></span></span>
 */
export const storeChatStateRpc = freeze({
  baseUrl,
  method: 'post',
  pathSegments: freeze(['v1/live-chat'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * post-/microapp-product-bridges/v1/meeting
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: internal ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:MeetingStateResource+type:symbol+storeState&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Meeting_State-post-%2Fmicroapp-product-bridges%2Fv1%2Fmeeting'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/post/api.hubapi.com%2Fmicroapp-product-bridges%2Fv1%2Fmeeting?showRequestDetails=true&body=%7B%22firstName%22:%22string%22,%22lastName%22:%22string%22,%22eventTitle%22:%22string%22,%22description%22:%22string%22,%22location%22:%22string%22,%22schedulingTitle%22:%22string%22,%22durationOptions%22:%5B0%5D,%22availabilityWindow%22:%5B%7B%22start%22:0,%22end%22:0%7D%5D,%22timezone%22:%22string%22,%22considerWorkingHours%22:false,%22sendConfirmationEmail%22:false,%22preMeetingReminder%22:false,%22reminders%22:%5B%7B%22numberOfTimeUnits%22:0,%22ticks%22:0,%22timeUnit%22:%22string%22%7D%5D%7D&authType=internal)</span></span><span style='padding-left: 12px'></span></span>
 */
export const storeMeetingStateRpc = freeze({
  baseUrl,
  method: 'post',
  pathSegments: freeze(['v1/meeting'])
});